import React from 'react';

const TenantAdminAuditLogFormModal = React.lazy(() => import('../components/FormModal'));
const tenantAdminAuditLogModalRegistry = {
    core_tenantAdminAuditLogId: TenantAdminAuditLogFormModal
};
export default tenantAdminAuditLogModalRegistry;
